import { get, post, put } from './Tools';

const getAll = async () => {
    const response = await get(`${process.env.REACT_APP_SERVER}odoo_puesto/get/all`);
    return response;
};

const getList = async () => {
    const response = await get(`${process.env.REACT_APP_SERVER}odoo_puesto/get/list`);
    return response;
};

const createOrUpdate = async (data) => {
    const response = await post(`${process.env.REACT_APP_SERVER}odoo_puesto`, data);
    return response;
};

const updateById = async (odooId, data) => {
    const response = await put(`${process.env.REACT_APP_SERVER}odoo_puesto/${odooId}`, data);
    return response;
};

export { getAll, getList, createOrUpdate, updateById };